export class Toolbar {
	private static _initialized = false;
	static init() {
		if (this._initialized) {
			return;
		}
		this._initialized = true;
		document.addEventListener('DOMContentLoaded', () => {
			const homepage_toolbar_mobile_menu = document.getElementById('homepage_toolbar_mobile_menu');
			const homepage_toolbar_collapser = document.getElementById('homepage_toolbar_collapser');
			const homepage_toolbar_expander = document.getElementById('homepage_toolbar_expander');

			const CLASS = {
				HIDDEN: 'hidden',
			};
			function collapse() {
				if (homepage_toolbar_mobile_menu) {
					homepage_toolbar_mobile_menu.classList.add(CLASS.HIDDEN);
				} else {
					console.warn('no #homepage_toolbar_mobile_expanded found');
				}
			}
			function expand() {
				if (homepage_toolbar_mobile_menu) {
					homepage_toolbar_mobile_menu.classList.remove(CLASS.HIDDEN);
				} else {
					console.warn('no #homepage_toolbar_mobile_expanded found');
				}
			}

			if (homepage_toolbar_collapser) {
				homepage_toolbar_collapser.addEventListener('click', collapse);
			} else {
				console.warn('no #homepage_toolbar_collapser found');
			}
			if (homepage_toolbar_expander) {
				homepage_toolbar_expander.addEventListener('click', expand);
			} else {
				console.warn('no #homepage_toolbar_collapser found');
			}
		});
	}
}
